/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const callApiWithToken = async(accessToken, apiEndpoint) => {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
    console.log(`token is ${accessToken}`);
    headers.append("Authorization", bearer);
   // headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');
   // headers.append('Access-Control-Allow-Credentials', 'true');    
    const options = {
        method: "GET",
        headers: headers,
    };

    return fetch(apiEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}

export const callApi = async(apiEndpoint) => {
    const headers = new Headers();
    
    const options = {
        method: "GET",
        headers: headers,
    };

    return fetch(apiEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}